/* eslint-disable import/no-unresolved */
import { useState } from "react";
import { useMutation } from "react-query";
import { countryCall } from "src/services/Master";
import CovidDetailsTogglebutton from "src/shared/CovidDetailsToggleButton";
import CustomAutocomplete from "src/shared/CustomAutocomplete";
// import CustomSelect from "src/shared/CustomSelect";
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
}

function TravelDetails({ formik }: Props) {
  const [countryOptions, setCountryOptions] = useState([]);
  const { mutate: mutateCountry } = useMutation(countryCall, {
    retry: false,
    onSuccess: async (response, variables) => {
      const countryResponse = response.data;
      const countryOccupationArray = countryResponse.reduce(
        (acc: string[], result: Record<string, any>) => {
          acc.push(result?.name);
          return acc;
        },
        []
      );
      setCountryOptions(countryOccupationArray);
      if (response.data?.length) {
        const exactCountryData = await response.data?.filter(
          (country: Record<string, any>) => country?.name === variables?.name
        );
        formik.setFieldValue("otherCountryTravel.countryNameCode", exactCountryData[0]?.code);
      }
    }
  });

  const handleCountryChange = async (value: string) => {
    // console.log("entering country");
    await formik.setFieldValue("otherCountryTravel.countryName", value);
    if (value) mutateCountry({ name: value });
  };
  return (
    <div>
      <div className="flex justify-between">
        <p className="text-daintree font-montserrat text-sm font-medium w-878/1000">
          Do you travel to any other country? If yes, then please specify the country(ies) names,
          purpose and duration of stay in these countries.*
        </p>
        <CovidDetailsTogglebutton
          isEnabled
          toggleState={formik.values.otherCountryTravel.isOtherCountryTravel}
          fieldObj="otherCountryTravel"
          fieldName="isOtherCountryTravel"
          setFieldValue={formik.setFieldValue}
        />
      </div>
      {formik.values.otherCountryTravel.isOtherCountryTravel && (
        <div className="flex flex-col md:flex-row justify-between mt-8">
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomAutocomplete
              onChange={handleCountryChange}
              setFieldTouched={formik.setFieldTouched}
              label="Country Name"
              name="otherCountryTravel.countryName"
              value={formik.values.otherCountryTravel?.countryName}
              setFieldValue={formik.setFieldValue}
              error={formik.errors.otherCountryTravel?.countryName}
              touched={formik.touched.otherCountryTravel?.countryName}
              options={countryOptions}
            />
          </div>
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="Duration(Months)"
              className=""
              // onChange={handleChange("otherCountryTravel.duration")}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.otherCountryTravel.duration}
              name="otherCountryTravel.duration"
              error={formik.errors.otherCountryTravel?.duration}
              touched={formik.touched.otherCountryTravel?.duration}
            />
          </div>
          <div className="w-full md:w-481/1000">
            <CustomTextField
              requiredStar
              label="Purpose"
              className=""
              // onChange={handleChange("otherCountryTravel.purpose")}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.otherCountryTravel?.purpose}
              name="otherCountryTravel.purpose"
              error={formik.errors.otherCountryTravel?.purpose}
              touched={formik.touched.otherCountryTravel?.purpose}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default TravelDetails;
